import { useState, useEffect, useRef } from 'react';

import clsx from 'clsx';

import {
  CloseOutlinedCompIcon,
  CheckCompIcon,
  EditIconOutlineComp,
} from 'assets/icons';
import styles from './styles.module.scss';

function FormField({
  label,
  value,
  isEditable,
  id,
  handleSubmitChange,
  error,
}) {
  const [onEditMode, setOnEditMode] = useState(false);
  const [onEditValue, setOnEditValue] = useState(value);
  const cancelBtRef = useRef(null);

  const getFormatedValue = (value) => value || '-';

  const handleEditBtnClick = () => setOnEditMode(true);

  const handleCancelBtnClick = () => {
    setOnEditMode(false);
    setOnEditValue(value);
  };

  const handleSubmitBtnClick = () => {
    handleSubmitChange(id, onEditValue);
    setOnEditMode(false);
  };

  const handleChangeInput = (e) => {
    setOnEditValue(e.target.value);
  };

  const handleBlurInput = (e) => {
    if (cancelBtRef.current?.contains(e.relatedTarget)) return;

    handleSubmitBtnClick();
  };

  const renderValue = onEditMode ? (
    <input
      className={styles.input}
      autoFocus={true}
      type='text'
      onBlur={handleBlurInput}
      onChange={handleChangeInput}
      value={onEditValue}
    />
  ) : (
    getFormatedValue(value)
  );

  const renderButtons = () => {
    // when on field is already being edited
    if (onEditMode) {
      return (
        <div className={styles.actions}>
          <button className={styles.button} onClick={handleSubmitBtnClick}>
            <CheckCompIcon
              className={clsx([styles.button__icon, styles.button__check])}
            />
          </button>
          <button
            className={styles.button}
            onClick={handleCancelBtnClick}
            ref={cancelBtRef}
          >
            <CloseOutlinedCompIcon
              className={clsx([styles.button__icon, styles.button__cancel])}
            />
          </button>
        </div>
      );
    }

    if (isEditable)
      return (
        <button className={styles.button} onClick={handleEditBtnClick}>
          <EditIconOutlineComp
            className={clsx([styles.button__icon, styles.button__edit])}
          />
        </button>
      );

    return null;
  };

  useEffect(() => {
    setOnEditValue(value);
  }, [value]);

  return (
    <>
      <div
        data-hasError={!!error}
        data-active={onEditMode}
        className={styles.user_info_item}
      >
        <div className={styles.user_info__inner}>
          <div className={styles.user_info_item_key}>
            <span className={styles.item_label}>{label}</span>
            {renderButtons()}
          </div>
          <div className={styles.user_info_item_value}>{renderValue}</div>
        </div>
      </div>
      <span className={styles.error_msg}>{error}</span>
    </>
  );
}

export default FormField;
